var map = {
	"./1.png": 5517,
	"./10.png": 9865,
	"./11.png": 6119,
	"./2.png": 1908,
	"./3.png": 2379,
	"./4.png": 8839,
	"./5.png": 6185,
	"./6.png": 1220,
	"./7.png": 1169,
	"./8.png": 9064,
	"./9.png": 8243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2185;